export interface TestConnectionPayload {
  exchangeId: string;
  credentials: Record<string, string>;
}

export interface SyncExchangePayload {
  exchange: string;
  credentials: Record<string, any>;
}

export async function testConnection(payload: TestConnectionPayload) {
  console.log('[exchangeApi] testConnection payload:', payload);
  const res = await fetch('/api/exchange/test-connection', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  if (!res.ok) throw new Error('Test connection failed');
  const data = await res.json();
  console.log('[exchangeApi] testConnection response:', data);
  return data;
}

export async function syncExchange(payload: SyncExchangePayload) {
  console.log('[exchangeApi] syncExchange payload:', payload);
  const res = await fetch('/api/exchange/sync', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  if (!res.ok) throw new Error('Sync failed');
  const data = await res.json();
  console.log('[exchangeApi] syncExchange response:', data);
  return data;
}
